<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="workstation"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :addButton="{ enabled: true }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: true, permission: 'default' }"
            :fuzzySearch="true"
        >
            <!-- <div slot="table-title" class="align-left padding5">
      当前工作站：
    </div> -->
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `WorkStation`,
    props: {

    },
    data() {
        return {
            title: `工作站设置`,
            work_station_type: 1,
            current_station: [],
            url: { baseURL: `/api/AcisSystem/WorkstationConfig`,
                get: () => {
                    return this.loadWorkStation()
                },
                post: (data) => {
                    if (this.current_station.length != 0 && this.current_station[0].token == this.localIp) {
                        this.$message.info(`该客户端已设置工作站，不能重复设置`)
                        return
                    }
                    return new Promise((resolve) => {
                        let r = {
                            dic_recovery_ward_id: data.work_station_type == 1 ? 0 : data.dic_recovery_ward_id,
                            dic_operating_room_id: data.dic_operating_room_id,
                            relation_dic_operating_room_ids: data.relation_dic_operating_room_ids,
                            default_printer_name: data.default_printer_name,
                            computer_name: data.computer_name,
                            token: data.token
                        }
                        if (r.dic_recovery_ward_id == 0 && r.dic_operating_room_id == undefined) {
                            this.$message.warning(`手术麻醉工作站手术间不能为空`)
                            return
                        }
                        let req = this.myaxios.post(`/api/AcisSystem/WorkstationConfig/Post`, r)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                },
                put: (data) => {
                    return new Promise((resolve, reject) => {
                        let r = {
                            id: data.id,
                            dic_recovery_ward_id: data.work_station_type == 1 ? 0 : data.dic_recovery_ward_id,
                            dic_operating_room_id: data.dic_operating_room_id || 0,
                            relation_dic_operating_room_ids: data.relation_dic_operating_room_ids,
                            default_printer_name: data.default_printer_name,
                            computer_name: data.computer_name,
                            token: data.token
                        }
                        if (r.dic_recovery_ward_id == 0 && r.dic_operating_room_id == 0) {
                            this.$message.warning(`手术麻醉工作站手术间不能为空`)
                            return
                        }
                        let req = this.myaxios.put(`/api/AcisSystem/WorkstationConfig/Put`, r)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                }
            },
            currentWorkStation: {}
        }
    },
    created() {
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`)
        this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`operation_ward_auth`, `operation_ward_auth_disabled`, `recovery_ward_auth`, `localip/ipAddress`, `ward_auth`]),
        localIp() {
            return this[`localip/ipAddress`]
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isKey: true
            }, {
                type: `select`,
                prop: `work_station_type`,
                label: `工作站类型`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: (that, { row }) => {
                    return [{ value: 1, label: `手术麻醉工作站`, code: `手术麻醉工作站` }, { value: 2, label: `苏醒工作站`, code: `苏醒工作站` }]
                },
                change: (that, { row }) => {
                    if (row.work_station_type === 2) {
                        row.dic_operating_room_id = null
                    }
                },
                default: 1
            }, {
                type: `select`,
                prop: `dic_recovery_ward_id`,
                label: `所属区域`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: (that, { row }) => {
                    if (row.work_station_type === 1) {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return d.disabled === false
                        })
                        return data
                    } else {
                        return this.recovery_ward_auth
                    }
                },
                change: (that, { row }) => {
                    row.dic_operating_room_id = undefined
                }
            }, {
                type: `select`,
                prop: `dic_operating_room_id`,
                label: `所在手术间`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                options: (that, { row }) => {
                    if (row.work_station_type === 1) {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return (d.value == row.dic_recovery_ward_id)
                        })
                        return _.filter(data[0] && data[0].operation_room, (d) => {
                            return d.disabled === false
                        }) || []
                    }
                    return []
                }
            }, {
                type: `multiselect`,
                prop: `relation_dic_operating_room_ids`,
                label: `关联手术间`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                collapseTags: false,
                options: (that, { row }) => {
                    if (row.work_station_type === 1) {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return (d.value == row.dic_recovery_ward_id)
                        })
                        return _.filter(data[0] && data[0].operation_room, (d) => {
                            return d.disabled === false
                        }) || []
                    }
                    return []
                }
            }, {
                type: `string`,
                prop: `default_printer_name`,
                label: `默认文书打印机`,
                isListable: true,
                isEditable: true,
                isCreatable: true
            }, {
                type: `string`,
                prop: `computer_name`,
                label: `计算机名称`,
                isListable: true,
                isEditable: true,
                isCreatable: true
            }, {
                type: `string`,
                prop: `token`,
                label: `本机IP`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                default: this.localIp,
                readonly: true
            }]
        }
    },
    mounted() {

    },
    methods: {
        loadWorkStation() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data && data.dic_operating_room_id || 0}`)
                        req1.then(d => {
                            data = {
                                dic_recovery_ward_id: d && d.dic_operating_ward_id || data.dic_recovery_ward_id,
                                dic_operating_room_id: data.dic_operating_room_id,
                                token: data.token,
                                relation_dic_operating_room_ids: data.relation_dic_operating_room_ids,
                                id: data.id,
                                default_printer_name: data.default_printer_name,
                                computer_name: data.computer_name,
                                work_station_type: data.dic_operating_room_id ? 1 : 2
                            }
                            this.current_station.push(data)
                            resolve(data, this.ward_auth)
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    },
    watch: {
        localIp: function() {
            this.$refs[`workstation`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WorkStation/Index.vue